import careerLogo1 from "/public/assets/images/main/career-logo/career01.png"
import careerLogo2 from "/public/assets/images/main/career-logo/career02.png"
import careerLogo3 from "/public/assets/images/main/career-logo/career03.png"
import careerLogo4 from "/public/assets/images/main/career-logo/career04.png"
import careerLogo5 from "/public/assets/images/main/career-logo/career05.png"
import careerLogo6 from "/public/assets/images/main/career-logo/career06.png"
import careerLogo7 from "/public/assets/images/main/career-logo/career07.png"
import careerLogo8 from "/public/assets/images/main/career-logo/career08.png"
import careerLogo9 from "/public/assets/images/main/career-logo/career09.png"
import careerLogo10 from "/public/assets/images/main/career-logo/career10.png"
import careerLogo11 from "/public/assets/images/main/career-logo/career11.png"
import careerLogo12 from "/public/assets/images/main/career-logo/career12.png"
import careerLogo13 from "/public/assets/images/main/career-logo/career13.png"
import careerLogo14 from "/public/assets/images/main/career-logo/career14.png"
import careerLogo15 from "/public/assets/images/main/career-logo/career15.png"
import careerLogo16 from "/public/assets/images/main/career-logo/career16.png"
import careerLogo17 from "/public/assets/images/main/career-logo/career17.png"

import NeedsItem01 from "/public/assets/images/main/needs/dojindo.png"
import NeedsItem02 from "/public/assets/images/main/needs/thewell.png"
import NeedsItem03 from "/public/assets/images/main/needs/euroimmun.png"
import NeedsItem04 from "/public/assets/images/main/needs/biotechne.png"
import NeedsItem05 from "/public/assets/images/main/needs/thermofisher.png"
import NeedsItem06 from "/public/assets/images/main/needs/xcell_v2.jpg"
import NeedsItem07 from "/public/assets/images/main/needs/quidel.png"
import NeedsItem08 from "/public/assets/images/main/needs/other.png"




export const MAIN_VISUAL_ITEMS = [
    {imageItem: "https://picsum.photos/id/1015/800/400"},
    {imageItem: "https://picsum.photos/id/1016/800/400"},
    {imageItem: "https://picsum.photos/id/1018/800/400"},
]

export const NEEDS_SLIDE_ITEMS = [
    {imageItem: NeedsItem01?.src, desc: "Dojindo"},
    {imageItem: NeedsItem02?.src, desc: "TheWell"},
    {imageItem: NeedsItem03?.src, desc: "Euroimmun"},
    {imageItem: NeedsItem04?.src, desc: "Biotechne"},
    {imageItem: NeedsItem05?.src, desc: "ThermoFisher"},
    {imageItem: NeedsItem06?.src, desc: "XCell"},
    {imageItem: NeedsItem07?.src, desc: "Quidel"},
    {imageItem: NeedsItem08?.src, desc: "View Other Brands"},
]

export const CAREER_LOGO_LIST = [
    {imageItem: careerLogo1?.src},
    {imageItem: careerLogo2?.src},
    {imageItem: careerLogo3?.src},
    {imageItem: careerLogo4?.src},
    {imageItem: careerLogo5?.src},
    {imageItem: careerLogo6?.src},
    {imageItem: careerLogo7?.src},
    {imageItem: careerLogo8?.src},
    {imageItem: careerLogo9?.src},
    {imageItem: careerLogo10?.src},
    {imageItem: careerLogo11?.src},
    {imageItem: careerLogo12?.src},
    {imageItem: careerLogo13?.src},
    {imageItem: careerLogo14?.src},
    {imageItem: careerLogo15?.src},
    {imageItem: careerLogo16?.src},
    {imageItem: careerLogo17?.src},
]
